export enum PlasticBagsWithHandlesLabels {
  type = "type",
  dimensions = "dimensions",
  material = "material",
  print = "print",
}
